import React, { useEffect, useState, useRef } from 'react';
import { observer } from 'mobx-react';
import { useStore } from '../../../stores';
import PreviewBrief from '../BriefPreview';
import BackIcon from '../../../assets/images/BackArrow.svg';
import EditIcon from '../../../assets/images/EditIcon.svg';
import { useServerFilter } from "../../../hooks/useServerFilter";
import { useServerFilterBriefs } from "../../../hooks/useBriefFilter";
import { truncateString , formatDate} from '../../../utils/sharedFunctions';
import './style.scss';
import { TextInput, AvailableProjects,SearchBar } from '../../../components';
const SearchIcon = `${process.env.REACT_APP_CDN_URL}/globalAssets/SearchIcon.svg`;
const UserIcon = `${process.env.REACT_APP_CDN_URL}/globalAssets/people.png`;

var mobile = require('is-mobile');

const ViewClient = observer(({ backClick, selectedPro, leads, pros, allUsers }) => {
    const { userStore, projectStore,briefStore,uiStore } = useStore();
    const [, updateState] = useState();
    const forceUpdate = React.useCallback(() => updateState({}), []);
    const [IsEdit, setIsEdit] = useState(false);
    const [activeTab, setActiveTab] = useState('profile');
    const [User, setUser] = useState(selectedPro);
    const [ViewProject, setViewProject] = useState(false);
    const [TypeSelected, setTypeSelected] = useState('Brief');
    const [Briefs, setBriefs] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [SelectedProject, setSelectedProject] = useState({});
    const [AllProjects, setAllProjects] = useState([]);
    const [FullName, setFullName] = useState('');
    const [Leads, setLeads] = useState([]);
    const [Professionals, setProfessionals] = useState([]);
    const [AvailProjects, setAvailBriefs] = useState([]);
    const [IsEdited, setIsEdited] = useState(false);
    const [Pagination, setPagination] = useState({ 
            currentPage :  1, 
            hasMore     : false, 
            nextCursor  : "", 
            prevCursor  : "",
            pageSize    : 8, 
            totalPages  : 0, 
            totalUsers  : 0
    })
    const didMount = useRef(false);
    const { serverFilterBriefs } = useServerFilterBriefs({ briefStore, uiStore, setBriefs, setPagination, searchTerm });
    const { serverFilterProject } = useServerFilter({ projectStore, uiStore, setAvailBriefs, setPagination, searchTerm });
    useEffect(() => {
        getUsers();
    }, []);
    useEffect(() => {
        if (!didMount.current) {
          // first render, do nothing
          didMount.current = true;
          return;
        }
            
        if (searchTerm !== "") {
          serverFilterProject(null, searchTerm, null, null, selectedPro._id, 5);
          serverFilterBriefs(null , searchTerm, null, selectedPro._id, 5);
        } else {
          serverFilterProject(null, null, null, null, selectedPro._id, 5);
          serverFilterBriefs(null, null, null, selectedPro._id, 5);
        }
      }, [searchTerm]);
    useEffect(() => {
        let allProjects = [...AvailProjects, ...Briefs];
        setAllProjects(allProjects);
    }, [AvailProjects, Briefs]);
    //#region functions
    const getUsers = async () => {
        uiStore.setLoading(true);
        try {
            let fullName = `${selectedPro?.firstName ??""} ${selectedPro?.lastName ??""}`;
            await Promise.all([
                serverFilterProject( "", "", "","", selectedPro._id, 5),
                serverFilterBriefs( "", "","", selectedPro._id, 5)
            ]).then(() => {
                setFullName(fullName);
                setLeads(leads);
                setProfessionals(pros);
                setUser(selectedPro);
                uiStore.setLoading(false);
            }); 
        } catch (e) {
            console.error(e);
            uiStore.showNotification('Failed to load client details.', 'error');
            uiStore.setLoading(false);
        };
    };

    const handleTabClick = (tab) => {
        setIsEdit(false);
        setActiveTab(tab);
        forceUpdate();
    };

    const handleEditUser = () => {
        setIsEdit(true);
        forceUpdate();
    };

    const handleNavigateToMainScreen = () => {
        backClick(false, IsEdited);
        forceUpdate();
    };

    const handleTabChange = (e) => {
        setTypeSelected(e.currentTarget.id);
        forceUpdate();
    };

    const handleSearchChange = (value) => {
        setSearchTerm(value);
    };

    const handleUserInfoChange = (e) => {
        const user = { ...User, professional: User.professional || { gender: '', languages: '' } };

        switch (e.currentTarget.id) {
            case 'FullName': {
                const parts = e.target.value.split(' ');
                user.firstName = parts[0] || '';
                user.lastName = parts[1] || '';
                setFullName(e.target.value);
                user.fullName = `${user.firstName} ${user.lastName}`;
                setFullName(user.fullName);
                break;
            }
            case 'Phone': user.phone = e.target.value; break;
            case 'Email': user.email = e.target.value; break;
            case 'AccountType': user.accountType = e.target.value; break;
            case 'paymentMethod': user.paymentMethod = e.target.value; break;
            case 'compName': user.companyName = e.target.value; break;
            case 'industry': user.companyIndustry = e.target.value; break;
            case 'vatnumber': user.companyVatNumber = e.target.value; break;
            case 'billing': user.companyAddress = e.target.value; break;
            case 'billing': user.address = e.target.value; break;
            case 'compReg': user.companyRegistrationNumber = e.target.value; break;
            case 'website': user.companyWebsite = e.target.value; break;
            default: uiStore.showNotification(`Unhandled input id: ${e.currentTarget.id}`, 'warning'); break;
        }
        setUser(user);
        forceUpdate();
    };

    const updateUserClicked = async () => {
        try {
            uiStore.setLoading(true);
            const user = { ...User };
            const id = user._id;

            delete user.briefs;
            delete user.projects;

            const update = await userStore.updateUserById(id, user);

            if (update !== 'error') {
                setIsEdited(true);
                setIsEdit(false);
                uiStore.showNotification('User updated successfully.', 'success');
                setUser(update);
            } else {
                uiStore.showNotification('Failed to update user.', 'error');
            }
        } catch (e) {
            console.error(e);
            uiStore.showNotification('An error occurred while updating the user.', 'error');
        }finally{
            uiStore.setLoading(false);
        }
    };

    const cancelUpdateUser = () => {
        setIsEdit(false);
        forceUpdate();
    };

    const getSelectedProject = (id) => {
        const selectedProject = AllProjects.find(p => p._id === id);
        if (!selectedProject) {
            uiStore.showNotification('Project not found.', 'error');
            return;
        }
        setSelectedProject(selectedProject);
        setViewProject(true);
        forceUpdate();
    };

    const backClicked = (e, isUpdate) => {
        if (isUpdate) {
            setIsEdited(true);
            backClick(false, true);
        } else {
            backClick(false, false);
            setViewProject(e);
            forceUpdate();
        }
    };
//#endregion
    if (mobile()) {
        return (
            <div></div>
        );
    } else {
        return (
            <>
                {ViewProject ?
                    <PreviewBrief AllUsers={allUsers} project={SelectedProject} navigateMainToPage={(e, isUpdate) => backClicked(e, isUpdate)} professionals={Professionals} leads={Leads} />
                    :
                    <div className='ViewUser-Container'>
                        <div className='userDetailsSection'>
                            <div className='user-info-headerSection'>
                                <img src={BackIcon} onClick={handleNavigateToMainScreen} />
                                {User.businessType  === 'company' || User.accountType ==="company" ?
                                    <p>{User.companyName ?? 'Not Assigned'}</p>
                                    :
                                    <p>{User.firstName || ''} {User.lastName || ''}</p>
                                }
                            </div>

                            <div className='user-info-bodySection'>
                                <div className='user-profile-CompDetails'>
                                    <div className='Profile-Picture'>
                                        <img src={UserIcon} style={{ width: '100%', height: '100%' }} />
                                    </div>
                                    {User.businessType  === 'company' || User.accountType ==="company" ?
                                        <div className='user-oragnisationDetails'>
                                            <p style={{ margin: '0px' }}>{User.companyWebsite || ''}</p>
                                            <p >{User.companyIndustry || ''}</p>
                                            <p style={{ margin: '0px' }}>{User.companyRegistrationNumber}</p>
                                        </div>
                                        :
                                        <div className='user-oragnisationDetails'>
                                            <p style={{ margin: '0px' }}>{User.companyName || ''}</p>
                                            <p >{User.email || ''}</p>
                                            <p style={{ margin: '0px' }}>{User.companyRegistrationNumber}</p>
                                        </div>
                                    }
                                </div>

                                <div className='userEdit-AccountDetails'>
                                    <div className="tab-container">
                                        <div className="tabs">
                                            <div className={`tab ${activeTab === 'profile' ? 'active' : ''}`} onClick={() => handleTabClick('profile')}>
                                                Profile
                                            </div>
                                            <div className={`tab ${activeTab === 'bank-details' ? 'active' : ''}`} onClick={() => handleTabClick('bank-details')}>
                                                Financial Details
                                            </div>
                                        </div>
                                        <div className={`underline ${activeTab}`}></div>
                                    </div>
                                    <img src={EditIcon} style={{ width: '5%', cursor: 'pointer' }} onClick={handleEditUser} />
                                </div>

                                {(IsEdit && activeTab === 'profile' && (User.businessType  === 'company' || User.accountType ==="company" )) ?
                                    <div className='user-credentials'>
                                        <div className='editname-Contact-Details'>
                                            <TextInput style={{ width: '47%' }} label='Company Name' placeholder='Company Name' value={User.companyName ?? ''} id='compName' onChange={handleUserInfoChange} />
                                            <TextInput style={{ width: '47%' }} label='Website' placeholder='Website' value={User.companyWebsite} id='website' onChange={handleUserInfoChange} />
                                        </div>
                                        <div className='editname-Contact-Details'>
                                            <TextInput style={{ width: '47%' }} label='Contact Number' placeholder='Contact Number' value={User.phone} id='Phone' onChange={handleUserInfoChange} />
                                            <TextInput style={{ width: '47%' }} label='Total Jobs' placeholder='Total Jobs' value={User.briefCount} id='jobcount' />
                                        </div>
                                        <div className='editname-Contact-Details'>
                                            <TextInput style={{ width: '47%' }} label='Company Industry' placeholder='Company Industry' value={User.companyIndustry} id='industry' onChange={handleUserInfoChange} />
                                        </div>

                                        <div className='action-section'>
                                            <button className='btn-Cancel' onClick={cancelUpdateUser}>Cancel</button>
                                            <button className='btn-Save' onClick={updateUserClicked}>Save</button>
                                        </div>
                                    </div>
                                    : (IsEdit && activeTab === 'profile') ?
                                        <div className='user-credentials'>
                                            <div className='editname-Contact-Details'>
                                                <TextInput style={{ width: '47%' }} label='Name & Surname' placeholder='Jerry Williams' value={`${User.firstName} ${User.lastName}`} id='FullName' onChange={handleUserInfoChange} />
                                                <TextInput style={{ width: '47%' }} label='Email' placeholder='Email' value={User.email} id='Email' onChange={handleUserInfoChange} />
                                            </div>
                                            <div className='editname-Contact-Details'>
                                                <TextInput style={{ width: '47%' }} label='Contact Number' placeholder='Contact Number' value={User.phone} id='Phone' onChange={handleUserInfoChange} />
                                                <TextInput style={{ width: '47%' }} label='Total Jobs' placeholder='Total Jobs' value={User.briefCount} id='jobcount' />
                                            </div>
                                            <div className='editname-Contact-Details'>
                                                <TextInput style={{ width: '47%' }} label='Industry' placeholder='Industry' value={User.companyIndustry} id='industry' onChange={handleUserInfoChange} />
                                            </div>

                                            <div className='action-section'>
                                                <button className='btn-Cancel' onClick={cancelUpdateUser}>Cancel</button>
                                                <button className='btn-Save' onClick={updateUserClicked}>Save</button>
                                            </div>
                                        </div>
                                        : (IsEdit && activeTab == 'bank-details') ?
                                            <div className='user-credentials'>
                                                <div className='editname-Contact-Details'>
                                                    <TextInput style={{ width: '47%' }} label='Company Registration' placeholder='w2eq324d5656f7' value={User.companyRegistrationNumber} id='compReg' onChange={handleUserInfoChange} />
                                                    <TextInput style={{ width: '47%' }} label='VAT Number' placeholder='123456789' value={User.companyVatNumber} id='vatnumber' onChange={handleUserInfoChange} />
                                                </div>
                                                <div className='editname-Contact-Details'>
                                                    <TextInput style={{ width: '47%' }} label='Billing Address' placeholder='billing address' value={User.companyAddress} id='billing' onChange={handleUserInfoChange} />
                                                </div>
                                                <div className='action-section'>
                                                    <button className='btn-Cancel' onClick={cancelUpdateUser}>Cancel</button>
                                                    <button className='btn-Save' onClick={updateUserClicked}>Save</button>
                                                </div>
                                            </div>
                                            :
                                            (activeTab === 'profile' && (User.businessType  === 'personal' || User.accountType ==="personal" || User.accountUsage ==="personal" || User.accountType ==="public" ) ) ?
                                                <div className='user-credentials'>
                                                    <div className='name-contactsection'>
                                                        <div className='namesect'>
                                                            <p className='placeHolder'>Name & Surname</p>
                                                            <p className='value'>{User.firstName || ''} {' '}{User.lastName || ''}</p>
                                                        </div>
                                                        <div className='contactsect'>
                                                            <p className='placeHolder'>Email</p>
                                                            <p className='value'>{User.email || 'Not Assigned'}</p>
                                                        </div>
                                                    </div>

                                                    <div className='email-roleSection'>
                                                        <div className='emailsect'>
                                                            <p className='placeHolder'>Contact Number</p>
                                                            <p className='value'>{User.phone || 'Not Assigned'}</p>
                                                        </div>
                                                        <div className='rolesect' >
                                                            <p className='placeHolder'>Address</p>
                                                            <p className='value'>{User.companyAddress ?? User.address??"Not Assigned"}</p>
                                                        </div>
                                                    </div>

                                                    <div className='email-roleSection'>
                                                        <div className='emailsect'>
                                                            <p className='placeHolder'>Total Jobs</p>
                                                            <p className='value'>{User.briefCount ?? 0}</p>
                                                        </div>
                                                        <div className='rolesect'>
                                                            <p className='placeHolder'>Website</p>
                                                            <p className='value'>{User.companyWebsite || 'Not Assigned'}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                : (activeTab === 'profile' && (User.businessType  === 'company' || User.accountType ==="company" || User.accountUsage ==="company")) ?
                                                    <div className='user-credentials'>
                                                        <div className='name-contactsection'>
                                                            <div className='namesect'>
                                                                <p className='placeHolder'>Company Name</p>
                                                                <p className='value'>{User.companyName}</p>
                                                            </div>
                                                            <div className='contactsect'>
                                                                <p className='placeHolder'>Website</p>
                                                                <p className='value'>{User.companyWebsite || 'Not Assigned'}</p>
                                                            </div>
                                                        </div>

                                                        <div className='email-roleSection'>
                                                            <div className='emailsect'>
                                                                <p className='placeHolder'>Contact Number</p>
                                                                <p className='value'>{User.phone || 'Not Assigned'}</p>
                                                            </div>
                                                            <div className='rolesect' >
                                                                <p className='placeHolder'>Total Jobs</p>
                                                                
                                                                <p className='value'>{User.briefCount ?? 0}</p>
                                                            </div>
                                                        </div>

                                                        <div className='email-roleSection'>
                                                            <div className='emailsect'>
                                                                <p className='placeHolder'>Company Industry</p>
                                                                <p className='value'>{User.companyIndustry ?? 'Not Assigned'}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    : (activeTab === 'bank-details') ?
                                                        <div className='user-credentials'>
                                                            <div className='email-roleSection'>
                                                                <div className='emailsect'>
                                                                    <p className='placeHolder'>Company Registration</p>
                                                                    <p className='value'>{User.companyRegistrationNumber || 'Not Assigned'}</p>
                                                                </div>
                                                                <div className='rolesect'>
                                                                    <p className='placeHolder'>VAT Number</p>
                                                                    <p className='value'>{User.companyVatNumber || 'Not Assigned'}</p>
                                                                </div>
                                                            </div>
                                                            <div className='email-roleSection'>
                                                                <div className='emailsect'>
                                                                    <p className='placeHolder'>Billing Address</p>
                                                                    <p className='value'>{User.companyAddress || 'Not Assigned'}</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        :
                                                        null
                                }
                            </div>
                        </div>
                        <div className='user-project-section'>
                            <div className='project-header-container'>
                                <p >{TypeSelected}</p>
                                <div className='search-bar-section' style={{ width: '45%' }}>
                                 <SearchBar
                                    onSearch={(e)=>handleSearchChange(e)}
                                    placeholder='Search'
                                    debounceDelay={1000}
                                    disabled={false}
                                    className=''
                                    searchIconUrl={SearchIcon}
                                    style={{ width: '100%' }}
                                />
                                </div>
                            </div>

                            <AvailableProjects
                                type={TypeSelected}
                                briefs={Briefs}
                                projects={AvailProjects}
                                truncateString={truncateString}
                                formatDate={formatDate}
                                user={User}
                                getSelectedProject={getSelectedProject}
                                searchTerm={searchTerm}
                            />
          
                            <div className='viewBriefTypeSect' style={{ width: '93%' }}>
                                <div className={(TypeSelected === 'Brief' ? 'selectedType' : 'typeCard')} id='Brief' onClick={handleTabChange}>
                                    <p>Briefs</p>
                                </div>
                                <div style={{ marginLeft: '1.5%' }} className={(TypeSelected === 'Project' ? 'selectedType' : 'typeCard')} id='Project' onClick={handleTabChange}>
                                    <p>Projects</p>
                                </div>
                            </div>
                        </div>
                    </div >
                }
            </>
        )
    }
})

export default ViewClient;